// extracted by mini-css-extract-plugin
module.exports = {"likedVideos-page":"likedVideos_likedVideos-page__fgyi9","video-grid":"likedVideos_video-grid__2EPfz"};